import { render, staticRenderFns } from "./HoldFilters.vue?vue&type=template&id=3781a1c0&scoped=true&"
import script from "./HoldFilters.vue?vue&type=script&lang=ts&setup=true&"
export * from "./HoldFilters.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./HoldFilters.vue?vue&type=style&index=0&id=3781a1c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3781a1c0",
  null
  
)

export default component.exports